import Layout from '@/layouts/Layout'

const customers = {
  path: '/customers',
  component: Layout,
  name: '',
}
export default customers
